module.exports = __webpack_public_path__ + "img/hover.7fcc5923.png";